module.exports = __webpack_public_path__ + "static/mockup-7b7cd226e3682a331794933e41348e2d.jpg";